import Accordion from 'accordion-js'

const filters = document.querySelector('#all-filters')
const accordion = document.querySelector('#accordion-filters')
const btn_open = document.querySelector('#btn-open-filters')
const btn_close = document.querySelector('#btn-close-filters')
const forms = document.querySelectorAll('.form-filters')
const btn_filter = document.querySelectorAll('.btn-filter')

if (!accordion) {
  return
}

new Accordion(accordion, {
  openOnInit: [0],
})

// close menu when click outside #sidebar
document.addEventListener('click', (event) => {
  if (event.target === filters) {
    toggleMenu()
  }
})

btn_open.addEventListener('click', () => {
  toggleMenu()
})

btn_close.addEventListener('click', () => {
  toggleMenu()
})

function toggleMenu() {
  filters.toggleAttribute('data-active')
  document.body.classList.toggle('overflow-hidden')
}

forms.forEach((form) => {
  form.addEventListener('submit', function (event) {
    event.preventDefault()

    let checkboxesProdType = form.querySelectorAll(
      'input[name="product_type"]:checked'
    )
    let checkboxesHairType = form.querySelectorAll(
      'input[name="hair_type"]:checked'
    )
    let checkboxesHairNeed = form.querySelectorAll(
      'input[name="hair_need"]:checked'
    )
    let checkboxesProdLine = form.querySelectorAll(
      'input[name="product_line"]:checked'
    )

    let valuesProdType = Array.from(checkboxesProdType)
      .map((cb) => cb.value)
      .filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    let valuesHairType = Array.from(checkboxesHairType)
      .map((cb) => cb.value)
      .filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    let valuesHairNeed = Array.from(checkboxesHairNeed)
      .map((cb) => cb.value)
      .filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    let valuesProdLine = Array.from(checkboxesProdLine)
      .map((cb) => cb.value)
      .filter((value, index, self) => {
        return self.indexOf(value) === index
      })

    let url = new URL(this.action)

    if (valuesProdType.length > 0) {
      url.searchParams.set('product_type', valuesProdType.join(','))
    }
    if (valuesHairType.length > 0) {
      url.searchParams.set('hair_type', valuesHairType.join(','))
    }
    if (valuesHairNeed.length > 0) {
      url.searchParams.set('hair_need', valuesHairNeed.join(','))
    }
    if (valuesProdLine.length > 0) {
      url.searchParams.set('product_line', valuesProdLine.join(','))
    }

    window.location.href = url
  })
})

function removeFilter(field, value) {
  let url = new URL(window.location.href)

  let values = url.searchParams.get(field)

  if (values) {
    let array = values.split(',')

    let index = array.indexOf(value)

    if (index > -1) {
      array.splice(index, 1)
    }

    if (array.length > 0) {
      url.searchParams.set(field, array.join(','))
    } else {
      url.searchParams.delete(field)
    }
  }

  window.location.href = url
}
window.removeFilter = removeFilter

btn_filter.forEach((btn) => {
  btn.addEventListener('click', function (event) {
    if (!event.target.closest('.dropdown')) {
      closeAllDropdowns()
      const next = btn.children[1]
      next.toggleAttribute('data-open')
    }
  })
})

document.addEventListener('click', (event) => {
  if (
    !event.target.classList.contains('btn-filter') &&
    !event.target.closest('.dropdown')
  ) {
    closeAllDropdowns()
  }
})

function closeAllDropdowns() {
  btn_filter.forEach((btn) => {
    btn.children[1].removeAttribute('data-open')
  })
}
